import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    textAlign: 'center',
    padding: '40px 20px',
  }}>
    <div style={{
      background: 'rgba(10, 12, 20, 0.85)',
      border: '1px solid rgba(0, 209, 209, 0.25)',
      borderRadius: 12,
      padding: '48px 40px 40px',
      maxWidth: 480,
      width: '100%',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.4)',
    }}>
      <h1 style={{
        fontFamily: "'Orbitron', sans-serif",
        fontSize: '5rem',
        color: '#00D1D1',
        marginBottom: 8,
        letterSpacing: 4,
        marginTop: 0,
      }}>
        404
      </h1>
      <h2 style={{
        fontFamily: "'Orbitron', sans-serif",
        fontSize: '1.4rem',
        color: '#E6E6E6',
        marginBottom: 16,
        fontWeight: 400,
      }}>
        Lost in the Verse
      </h2>
      <p style={{
        color: '#8a8fa8',
        fontSize: '1rem',
        maxWidth: 420,
        lineHeight: 1.6,
        marginBottom: 32,
        margin: '0 auto 32px',
      }}>
        The coordinates you entered don't match any known location.
        This page may have been moved, deleted, or never existed.
      </p>
      <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
        <Link
          to="/"
          style={{
            background: '#00D1D1',
            color: '#0a0c14',
            padding: '10px 24px',
            borderRadius: 6,
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '0.95rem',
          }}
        >
          Return Home
        </Link>
        <Link
          to="/commodities"
          style={{
            background: 'transparent',
            color: '#00D1D1',
            padding: '10px 24px',
            borderRadius: 6,
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '0.95rem',
            border: '1px solid #00D1D1',
          }}
        >
          Browse Commodities
        </Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
